import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import {
  Code,
  Database,
  Cloud,
  Layout,
  CheckCircle,
  Users,
  Building2,
  ShoppingCart,
  Factory,
  Rocket,
  Heart,
  Target,
  Award,
  TrendingUp,
  Mail,
  Phone,
  Linkedin,
  Menu,
  X,
  ArrowUp, GraduationCap
} from 'lucide-react';
import './App.css';
import SectionFormation from "./components/SectionFormation";
import SectionApproche from "./components/SectionApproche";
import SectionPositionnement from "./components/SectionPositionnement";
import heroImg from "./assets/hero.jpg";
import uff from "./assets/uff.webp";

// Configuration EmailJS - À configurer dans Cloudflare Pages Environment Variables
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
const EMAILJS_CONTACT_TEMPLATE = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE || 'YOUR_CONTACT_TEMPLATE_ID';
const EMAILJS_CAREER_TEMPLATE = process.env.REACT_APP_EMAILJS_CAREER_TEMPLATE || 'YOUR_CAREER_TEMPLATE_ID';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [contactForm, setContactForm] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phone: '',
    needType: 'Recruter un profil',
    message: ''
  });
  const [careerForm, setCareerForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    message: '',
    cvLink: ''
  });
  const [contactStatus, setContactStatus] = useState({ type: '', message: '' });
  const [careerStatus, setCareerStatus] = useState({ type: '', message: '' });

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus({ type: 'loading', message: 'Envoi en cours...' });
    
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE,
        {
          firstName: contactForm.firstName,
          lastName: contactForm.lastName,
          company: contactForm.company,
          email: contactForm.email,
          phone: contactForm.phone,
          needType: contactForm.needType,
          message: contactForm.message,
        },
        EMAILJS_PUBLIC_KEY
      );
      
      setContactStatus({ 
        type: 'success', 
        message: 'Votre message a été envoyé avec succès. Nous vous recontacterons rapidement.' 
      });
      
      setContactForm({
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        phone: '',
        needType: 'Recruter un profil',
        message: ''
      });
    } catch (error) {
      console.error('EmailJS error:', error);
      setContactStatus({ 
        type: 'error', 
        message: 'Une erreur est survenue. Veuillez réessayer ou nous contacter directement par téléphone.' 
      });
    }
  };

  const handleCareerSubmit = async (e) => {
    e.preventDefault();
    setCareerStatus({ type: 'loading', message: 'Envoi en cours...' });
    
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CAREER_TEMPLATE,
        {
          firstName: careerForm.firstName,
          lastName: careerForm.lastName,
          email: careerForm.email,
          phone: careerForm.phone,
          position: careerForm.position,
          cvLink: careerForm.cvLink,
          message: careerForm.message,
        },
        EMAILJS_PUBLIC_KEY
      );
      
      setCareerStatus({ 
        type: 'success', 
        message: 'Votre candidature a été envoyée avec succès. Nous examinerons votre profil et vous recontacterons.' 
      });
      setCareerForm({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        message: '',
        cvLink: ''
      });
    } catch (error) {
      setCareerStatus({ 
        type: 'error', 
        message: error.response?.data?.detail || 'Une erreur est survenue. Veuillez réessayer.' 
      });
    }
  };

  const expertises = [
    {
      icon: <Code className="w-8 h-8" />,
      title: 'Développement Web & Mobile',
      description: 'Applications modernes et performantes, développées avec l\'appui d\'agents IA pour accélérer le delivery, la documentation et la qualité du code.'
    },
    {
      icon: <Database className="w-8 h-8" />,
      title: 'Data & IA',
      description: 'Data engineering, machine learning et conception d\'agents IA spécialisés pour automatiser vos processus métiers et activer pleinement la valeur de vos données.'
    },
    {
      icon: <Cloud className="w-8 h-8" />,
      title: 'DevOps & Cloud',
      description: 'Pipelines CI/CD intelligents, automatisations avancées, supervision améliorée par IA, optimisation continue des environnements cloud.'
    },
    {
      icon: <Layout className="w-8 h-8" />,
      title: 'Product management',
      description: 'Product discovery augmentée, analyse utilisateur assistée par IA, prototypage accéléré, prise de décision plus rapide et plus fiable.'
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'RPA : automatisation intelligente des process',
      description: 'Automatisation des tâches répétitives et chronophages grâce à des robots logiciels, intégration fluide avec vos systèmes existants, et amélioration continue des processus grâce à l\'IA.'
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Conseil & Transformation',
      description: 'Audit IA-ready, analyse de maturité, feuille de route Agents IA, transformation complète des processus.'
    }
  ];

  const offers = [
    {
      title: 'Formation IA',
      description: 'Former vos équipes à l\'IA pour qu\'elles l\'utilisent efficacement au quotidien — décideurs, équipes métiers et profils techniques.',
      benefits: [
        'Sensibilisation des décideurs & managers (CODIR)',
        'Formation pratique des équipes métiers (RH, marketing, ops…)',
        'Formation avancée pour profils techniques',
        'Cas concrets issus du terrain, mise en pratique immédiate'
      ]
    },
    {
      title: 'Centre de Services & Projet Clé en Main',
      description: 'Du cas d\'usage identifié à la solution IA déployée en production — agents IA conversationnels, automatisation des processus, applications métiers.',
      benefits: [
        'Développement rapide de POC',
        'Passage en production garanti',
        'Équipe projet augmentée par l\'IA',
        'Amélioration continue après déploiement'
      ]
    },
    {
      title: 'Accompagnement & Régie',
      description: 'Nos experts s\'intègrent directement dans vos équipes pour accélérer vos projets IA — Data & IA, DevOps, Product & UX, QA & Automation.',
      benefits: [
        'Experts expérimentés + compétences IA',
        'Intégration rapide dans vos équipes',
        'Transparence totale sur TJM & rémunération',
        'Montée en compétence IA continue'
      ]
    }
  ];

  const sectors = [
    { icon: <Building2 className="w-8 h-8" />, name: 'Banque & Assurance', description: 'Automatisation des processus et analyse de risque par IA.' },
    { icon: <ShoppingCart className="w-8 h-8" />, name: 'Retail & E-commerce', description: 'Personnalisation client et gestion des stocks intelligente.' },
    { icon: <Factory className="w-8 h-8" />, name: 'Industrie & Énergie', description: 'Maintenance prédictive et supervision intelligente.' },
    { icon: <Rocket className="w-8 h-8" />, name: 'Startups & Scale-ups', description: 'Développement rapide et mise en production accélérée par l\'IA.' }
  ];

  const values = [
    {
      icon: <Heart className="w-8 h-8" />,
      title: 'Proximité',
      description: 'Accompagnement personnalisé, clair et sincère.'
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: 'Transparence',
      description: 'Tarif et conditions de collaboration présentés de manière compréhensible et honnête.'
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: 'Exigence',
      description: 'Engagement sur la qualité technique, avec l\'IA utilisée pour renforcer les résultats.'
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: 'Innovation',
      description: 'Exploration et expérimentation des agents IA, veille technologique continue.'
    }
  ];

  // Animation au scroll de la page
  useEffect(() => {
    const elements = document.querySelectorAll("[data-animate]");

    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.setAttribute("data-visible", "true");
              observer.unobserve(entry.target) // animation une seule fois
            }
          })
        },
        {
          threshold: 0.15,
        }
    );

    elements.forEach(entry => observer.observe(entry));

    return () => observer.disconnect();
  }, []);

  const [showButton, setShowButton] = useState(false);

  // Visibilité du bouton scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    }

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [activeSection, setActiveSection] = useState('accueil');

  // Indicateur de la section active
  useEffect(() => {
    const sections = ['accueil', 'formation', 'expertises', 'offres', 'secteurs', 'carrieres']

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id)
        }
      })
    }, {threshold: 0.2,})

    sections.forEach((id) => {
      const elt = document.getElementById(id)
      if (elt)
        observer.observe(elt)
    })

    return () => observer.disconnect()
  }, [])

  const clients = [
    { name: "Le Figaro", type: 'svg', logo: (
          <svg xmlns="http://www.w3.org/2000/svg" width="414" height="45" fill="none" viewBox="0 0 414 45" className="w-full max-w-[400px] h-auto"><path fill="#163860" d="M293.866 10.138c-14.794 0-20.17 9.146-20.17 16.5 0 9.743 7.397 17.189 20.032 17.189 11.257 0 20.078-5.653 20.078-16.776 0-10.57-8.454-16.913-19.94-16.913Zm.23 26.795c-3.4 0-7.03-1.793-7.03-10.893 0-5.607 2.435-9.1 6.616-9.1 3.951 0 6.846 2.298 6.846 9.698 0 8.089-2.986 10.295-6.432 10.295ZM125.615 36.427v6.572h20.997v-6.572h-3.308a.872.872 0 0 1-.873-.873V18.41c0-.46.368-.873.873-.873h3.354v-6.573h-20.997v6.573h3.354c.46 0 .873.367.873.873v17.143c0 .46-.367.873-.873.873h-3.4ZM189.479 28.384v-2.758h-18.93v5.7h6.846s.138 6.204-7.305 6.204c-4.043 0-8.224-2.344-8.224-10.479s5.927-10.34 9.556-10.34c3.998 0 6.938 1.562 8.592 4.044h8.316v-9.698h-8.27v2.62s-4.411-3.401-12.221-3.401c-11.165 0-19.251 6.204-19.251 16.821 0 9.79 7.259 16.591 20.767 16.591 20.124 0 20.124-15.304 20.124-15.304Z"/><path fill="#163860" d="m226.189 35.508-10.107-24.543h-13.738s-7.581 19.028-10.016 24.589c-.23.551-.781.873-1.378.873h-2.527v6.572h14.748v-6.572h-1.976c-.643 0-1.056-.644-.827-1.195l.919-2.16h12.038l.873 2.16c.229.551.138 1.195-.46 1.195h-2.573v6.572h18.746v-6.572h-2.343a1.505 1.505 0 0 1-1.379-.92Zm-22.696-7.767 3.813-9.284 3.859 9.284h-7.672ZM268.227 35.783l-4.226-6.112s6.432-1.333 6.432-8.043c0-6.434-5.376-10.663-14.978-10.663h-24.029v6.573h3.354c.459 0 .873.367.873.873v17.143c0 .46-.368.873-.873.873h-2.206v6.572h19.848v-6.572h-3.353a.872.872 0 0 1-.873-.873v-4.32h3.905l8.086 11.765h12.773v-6.572h-3.538c-.459 0-.919-.23-1.195-.644Zm-15.161-10.248h-4.87v-7.997h4.87s5.881-.138 5.881 3.906c0 0 .413 4.09-5.881 4.09ZM.555 43V36.38h3.354c.46 0 .873-.368.873-.873V18.41a.872.872 0 0 0-.873-.873H.555v-6.573H21.55v6.573h-3.354a.872.872 0 0 0-.872.873v17.97l8.224.046a.845.845 0 0 0 .873-.873v-5.837h8.224v13.282H.555ZM71.906 19.606v-8.64H37.77v6.572h3.355c.459 0 .872.367.872.873v17.097c0 .46-.367.873-.873.873H37.77v6.618h34.136v-8.686h-6.983v1.24a.873.873 0 0 1-.873.874l-9.465-.046v-6.526h10.338v-6.021H54.585v-6.296l9.465-.046c.505 0 .873.367.873.873v1.24h6.983ZM89.963 10.965c.322.23.644.506 1.011.736 8.178 6.066 8.27 10.34 8.27 10.34v8.917c-2.573-.782-4.686-1.655-6.386-2.528v7.124c0 .46-.368.873-.873.873H88.63v6.572h20.813v-6.572h-3.17a.872.872 0 0 1-.873-.873V29.9h9.051V23.88h-9.097v-6.342l8.224-.046c.505 0 .873.367.873.873v1.24h8.224v-8.64H89.963Z"/><path fill="#0D6FEF" d="M105.446 32.66c1.011.183 3.814 1.654 5.008 2.62 3.308 2.665 6.8 6.755 6.8 6.755l1.516.965s-4.273-5.101-6.983-7.813a499.296 499.296 0 0 1-5.146-5.147l-.184-.184H105.4v2.803h.046ZM90.974 11.702c-.368-.276-.69-.506-1.011-.736C82.566 5.36 80.13 2.372 79.488.396c0 0-2.252 8.134 3.767 14.569 0 0-1.47-.322-2.849-.873 0 0 2.481 6.204 9.327 9.513 0 0-1.792.046-3.308-.138 0 0 1.608 2.436 6.432 4.964 1.7.873 3.814 1.746 6.387 2.528v-8.916s-.092-4.275-8.27-10.341Z"/><path fill="#163860" d="M329.516 42.338v-3.454l9.146-11.482c1.838-2.556 3.362-4.934 3.362-8.118 0-3.185-1.12-6.952-4.976-6.952-1.031 0-2.69.627-2.69 1.883 0 1.077 2.062 1.256 2.062 3.992 0 1.929-1.434 3.32-3.362 3.32-2.332 0-3.676-1.84-3.676-4.082 0-4.26 4.438-7.445 9.907-7.445 5.739 0 10.356 3.633 10.356 8.791 0 7.221-8.518 9.15-14.704 17.044h9.459c4.662 0 1.479-2.87 4.527-2.87h.673v9.373h-20.084ZM361.904 42.988c-.137.058-.295.057-.447.057-3.273 0-2.882-14.118-2.882-16.405 0-2.287-.225-16.54 3.093-16.54s3.093 14.252 3.093 16.54c0 2.065.146 13.776-2.235 16.029 1.608-1.087 5.295-3.543 7.922-5.046 1.653-3.275 2.159-7.467 2.159-11.028 0-7.221-2.018-16.595-10.984-16.595-8.966 0-10.894 9.284-10.894 16.326s1.717 16.82 10.773 16.82M381.577 25.496c.11-.072.225-.145.343-.22.003-4.238.192-14.972 3.097-14.972 2.256 0 2.874 6.878 3.039 11.644 1.033-.514 1.741-.85 1.741-.85l.941-.454a82.3 82.3 0 0 0 4.209-2.122C393.612 13.854 390.72 10 384.972 10c-8.697 0-10.894 9.284-10.894 16.326 0 1.621.098 3.362.351 5.087.543-.502 4.632-4.266 7.147-5.917h.001Z"/><path fill="#163860" d="M374.482 36.96c-.838-.023-3.338.687-4.482 1.277a52.5 52.5 0 0 0-6.627 4.315l-1.397.51s4.29-3.388 6.958-5.131c1.863-1.22 5.384-5.135 5.384-5.135s4.491-4.186 7.179-5.949c2.687-1.763 8.187-4.38 8.187-4.38l.937-.452c6.902-3.262 9.39-5.272 10.243-6.77 0 0 .454 6.93-5.5 11.14a16.689 16.689 0 0 0 2.457-.21 16.478 16.478 0 0 1-9.133 6.12c.887.21 1.787.365 2.694.46 0 0-1.717 1.709-6.02 2.907a31.202 31.202 0 0 1-5.581.98l-5.3.317.001.001Z"/><path fill="#163860" d="M377.411 38c-.203 0-.514.085-.514.342 0 .128.054.246.054.375 0 .407-.364.664-.739.664-.396 0-.803-.279-.803-.707 0-.922 1.306-1.19 2.109-1.19.289 0 2.451.011 2.451 2.271v1.467c0 .161-.085.975.279.975.107 0 .214-.075.278-.16l.053.075c.054.075.14.16.14.257 0 .289-.632.61-.932.61-.674 0-.995-.322-1.241-.825-.482.6-.942.825-1.702.825-.921 0-1.778-.504-1.778-1.51 0-1.575 2.227-1.832 3.191-2.025.01-.546-.129-1.446-.846-1.446V38Zm.868 1.97c-.771.085-1.445.567-1.445 1.392 0 .354.171.921.61.921.728 0 .834-.985.834-1.51v-.804h.001ZM384.157 37.56v.525c.503-.43.899-.6 1.563-.6 1.285 0 1.766.685 1.766 1.714v2.517c0 .846.6.235.6.953v.16h-2.859v-.16c0-.717.568-.107.568-.953v-2.603c0-.429-.097-.879-.707-.879-.267 0-.685.14-.846.386v3.095c0 .825.642.214.642.953v.16h-2.933v-.16c0-.717.6-.107.6-.953v-2.967c0-.846-.6-.235-.6-.953v-.16l2.205-.076h.001ZM390.944 42.135c0 .235.492.289.653.289.439 0 1.039-.182 1.039-.718 0-1.017-2.933-.653-2.933-2.463 0-1.264 1.284-1.756 2.366-1.756.621 0 1.766.214 1.766 1.028 0 .397-.364.664-.739.664-.331 0-.706-.214-.706-.578 0-.108.075-.268.075-.343 0-.172-.353-.214-.482-.214-.321 0-.781.192-.781.578 0 .997 2.922.515 2.922 2.431 0 1.34-1.402 1.928-2.547 1.928-.749 0-2.109-.246-2.109-1.22 0-.43.342-.718.749-.718s.814.278.814.717c0 .086-.022.15-.054.236a.638.638 0 0 0-.032.14l-.001-.002Z"/></svg>
      )},
    { name: "UFF", type: 'img', logo: uff },
  ];

  return (
    <div className="bg-background min-h-screen">
      {/* Header */}
      <header className="bg-white shadow-sm fixed w-full top-0 z-50">
        <nav className="container mx-auto px-6">
          <div className="flex items-center justify-between w-full">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_preview-launcher-7/artifacts/zl4uq45c_logo_1.png" 
                alt="NailixIA Logo" 
                className="logo"
              />
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex text-xs md:text-sm lg:text-base items-center space-x-8">
              <button onClick={() => scrollToSection('accueil')}
                      className={`transition ${activeSection === 'accueil' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Accueil
              </button>
              <button onClick={() => scrollToSection('formation')}
                      className={`transition ${activeSection === 'formation' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Catalogue de formations
              </button>
              <button onClick={() => scrollToSection('expertises')}
                      className={`transition ${activeSection === 'expertises' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Nos expertises
              </button>
              <button onClick={() => scrollToSection('offres')}
                      className={`transition ${activeSection === 'offres' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Nos offres
              </button>
              <button onClick={() => scrollToSection('secteurs')}
                      className={`transition ${activeSection === 'secteurs' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Secteurs
              </button>
              <button onClick={() => scrollToSection('carrieres')}
                      className={`transition ${activeSection === 'carrieres' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>
                Carrières
              </button>
              {/*<button onClick={() => scrollToSection('contact')}*/}
              {/*        className={`transition ${activeSection === 'contact' ? 'text-accent font-medium border-b-2 border-accent' : 'text-primary hover:text-accent' }`}>*/}
              {/*  Contact*/}
              {/*</button>*/}
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-accent text-white px-6 py-2 rounded-lg hover:bg-opacity-90 transition"
                data-testid="header-contact-btn"
              >
                Nous contacter
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-primary"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
              aria-label="Ouvrir le menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed bg-white/70 backdrop-blur inset-0 z-50 top-20 flex flex-col justify-start items-end space-y-6 pr-6 cursor-pointer">
          <button onClick={() => scrollToSection('accueil')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Accueil
          </button>
          <button onClick={() => scrollToSection('formation')}
                  className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Catalogue de formations
          </button>
          <button onClick={() => scrollToSection('expertises')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Nos expertises
          </button>
          <button onClick={() => scrollToSection('offres')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Nos offres
          </button>
          <button onClick={() => scrollToSection('secteurs')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Secteurs
          </button>
          <button onClick={() => scrollToSection('carrieres')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Carrières
          </button>
          <button onClick={() => scrollToSection('contact')} className="block w-auto text-right text-primary hover:text-accent transition py-1">
            Contact
          </button>
        </div>
      )}

      {/* Hero Section - Optimisé SEO */}
      <section id="accueil" className="pt-28 pb-8 px-4 sm:px-6 lg:px-8" data-testid="hero-section" itemScope itemType="https://schema.org/Organization">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <p className="bg-accent/20 w-fit py-2 px-3 rounded-full text-sm mx-auto before:content-[''] before:w-1.5 before:h-1.5 before:rounded-full before:bg-accent before:animate-pulse before:inline-block flex items-center gap-2 my-4">
                Cabinet IA nouvelle génération
              </p>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary mb-6 md:mb-10 leading-tight">
                De la formation à la mise en production de solutions IA
              </h1>
              <p className="text-lg md:text-xl max-w-4xl mx-auto text-gray-600 mb-6 md:mb-10 px-4 leading-relaxed" itemProp="description">
                Nous transformons l'IA en solutions opérationnelles. Formation, identification de cas d'usage, développement et déploiement — nous faisons le lien entre tout.
              </p>
              {/*<p className="text-base text-gray-500 mb-10 px-4">*/}
              {/*  Développement web & mobile • Data & Machine Learning • DevOps & Cloud • RPA & Automatisation • Conseil IA*/}
              {/*</p>*/}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                    onClick={() => scrollToSection('contact')}
                    className="bg-accent text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-opacity-90 transition"
                    data-testid="hero-contact-btn"
                    aria-label="Contacter NailixIA pour discuter de votre projet IA"
                >
                  Discuter de votre projet
                </button>
                <button
                    onClick={() => scrollToSection('carrieres')}
                    className="bg-white border-2 border-accent text-accent px-8 py-4 rounded-lg text-lg font-semibold hover:bg-accent hover:text-white transition"
                    data-testid="hero-careers-btn"
                    aria-label="Rejoindre l'équipe NailixIA - Carrières"
                >
                  Rejoindre NailixIA
                </button>
              </div>
              <div className="flex flex-row justify-center lg:justify-start border rounded divide-x w-fit mx-auto lg:mx-0 mt-8">
                <div className="p-3 text-center">
                  <p className="text-accent text-xl md:text-3xl font-semibold">3</p>
                  <p className="text-sm text-gray-600">piliers d'expertises</p>
                </div>
                <div className="p-3 text-center">
                  <p className="text-accent text-xl md:text-3xl font-semibold">100%</p>
                  <p className="text-sm text-gray-600">orientés résultats</p>
                </div>
                <div className="p-3 text-center">
                  <p className="text-accent text-xl md:text-3xl font-semibold">bout en bout</p>
                  <p className="text-sm text-gray-600">formation → production</p>
                </div>
              </div>
            </div>
            <div className="flex-1 w-full max-w-lg mx-auto lg:mx-0">
              <picture>
                <img
                    src={heroImg}
                    alt="Robot IA entouré de dashboards analytiques — NailixIA cabinet conseil intelligence artificielle"
                    width="800"
                    height="600"
                    className="rounded-xl w-full object-cover"
                    loading="eager"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/* Formation Section */}
      <SectionFormation />

      {/*/!* SectionCLient *!/*/}
      {/*<SectionClient />*/}

      {/* Section Positionnement */}
      <SectionPositionnement />

      {/* Expertises Section - Optimisé SEO */}
      <section id="expertises" className="py-20 px-6 bg-white" data-testid="expertises-section" aria-labelledby="expertises-title" >
        <div className="container mx-auto">
          <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            Expertises
          </p>
          <h2 id="expertises-title" data-animate className="text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Nos Expertises en Intelligence Artificielle & Digital
          </h2>
          <p data-animate className="text-center text-gray-600 mb-6 max-w-3xl mx-auto text-lg opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            <strong>NailixIA</strong> intègre l'<strong>intelligence artificielle</strong> dans tous ses domaines d'expertise. Nos consultants utilisent des <strong>agents IA</strong> pour accélérer chaque projet.
          </p>
          <p data-animate className="text-center text-gray-500 mb-12 max-w-2xl mx-auto opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Développement • Data & IA • Cloud • Product • RPA • Transformation Digitale
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {expertises.map((expertise, index) => (
              <article 
                key={index} 
                className="bg-background p-6 rounded-xl hover-lift border-l-2 border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid={`expertise-card-${index}`}
                itemScope 
                itemType="https://schema.org/Service"
                data-animate
              >
                <div className="w-12 h-12 bg-accent/20 flex items-center justify-center rounded-xl mb-2">
                  <div data-animate className="text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">{expertise.icon}</div>
                </div>
                <h3 data-animate className="text-xl font-bold text-primary mb-3 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" itemProp="name">{expertise.title}</h3>
                <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" itemProp="description">{expertise.description}</p>
              </article>
            ))}
          </div>
          
          {/* Bloc SEO supplémentaire */}
          <div className="mt-16 max-w-4xl mx-auto text-center">
            <h3 data-animate className="text-2xl font-bold text-primary mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Pourquoi choisir une agence digitale IA comme NailixIA ?</h3>
            <p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              Dans un contexte de <strong>transformation digitale</strong> accélérée, les entreprises ont besoin de partenaires capables de combiner expertise technique et <strong>intelligence artificielle</strong>. <strong>NailixIA</strong> se positionne comme une <strong>agence digitale nouvelle génération</strong>, où chaque consultant maîtrise les outils d'<strong>IA générative</strong> et la création d'<strong>agents IA métiers</strong>. Que ce soit pour du <strong>développement web et mobile</strong>, du <strong>data engineering</strong>, du <strong>DevOps cloud</strong> ou de l'<strong>automatisation RPA</strong>, nous apportons une valeur ajoutée unique : l'IA au service de vos projets.
            </p>
          </div>
        </div>
      </section>

      {/* Offres Section - Optimisé SEO */}
      <section id="offres" className="py-20 px-6" data-testid="offres-section" aria-labelledby="offres-title">
        <div className="container mx-auto">
          <h2 className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            Offres
          </h2>
          <h3 id="offres-title" data-animate className="text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Notre offre de Services IT & IA
          </h3>
          <p data-animate className="text-center text-gray-600 mb-12 max-w-2xl mx-auto text-lg opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            <strong>NailixIA</strong> propose des offres adaptées à vos besoins : régie, forfait ou conseil. Toutes augmentées par l'<strong>intelligence artificielle</strong>.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {offers.map((offer, index) => (
              <article 
                key={index} 
                className="bg-white p-8 rounded-xl shadow-lg hover-lift opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid={`offer-card-${index}`}
                itemScope
                itemType="https://schema.org/Offer"
                data-animate
              >
                <h3 data-animate className="text-2xl font-bold text-primary mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" itemProp="name">{offer.title}</h3>
                <p data-animate className="text-gray-600 mb-6 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" itemProp="description">{offer.description}</p>
                <ul className="space-y-3">
                  {offer.benefits.map((benefit, idx) => (
                    <li key={idx} data-animate className="flex items-start opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                      <CheckCircle className="w-5 h-5 text-accent mr-3 mt-1 flex-shrink-0" aria-hidden="true" />
                      <span className="text-gray-700">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
        {/* Approche Section */}
        <SectionApproche />
      </section>

      {/* Secteurs Section - Optimisé SEO */}
      <section id="secteurs" className="py-20 px-6 bg-white" data-testid="secteurs-section" aria-labelledby="secteurs-title">
        <div className="container mx-auto">
          <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            Secteurs
          </p>
          <h2 id="secteurs-title" data-animate className="text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Secteurs d'Activité : NailixIA au Service de Votre Industrie
          </h2>
          <p data-animate className="text-center text-gray-600 mb-12 max-w-2xl mx-auto opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            <strong>NailixIA</strong> accompagne les entreprises de tous secteurs dans leur <strong>transformation digitale</strong> et l'intégration de l'<strong>intelligence artificielle</strong>.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {sectors.map((sector, index) => (
                <article
                    key={index}
                    className="bg-gradient-to-br from-accent via-[#0284C7] to-[#0369A1] p-6 rounded-2xl relative overflow-hidden text-left hover-lift hover:-translate-y-1 hover:shadow-2xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid={`sector-card-${index}`}
                    data-animate
                >
                  <div className="absolute -top-5 -right-5 w-24 h-24 bg-blue-400/20 rounded-full"></div>
                  <div data-animate className="w-14 h-14 bg-[#0284C7] rounded-xl flex items-center justify-center my-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                    <div data-animate
                         className="text-white opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                         aria-hidden="true"
                    >
                      {sector.icon}
                    </div>
                  </div>
                  <h3 data-animate
                      className="text-lg font-semibold text-white opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                    {sector.name}
                  </h3>
                  <p data-animate className="text-sm text-gray-300 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">{sector.description}</p>
                </article>
            ))}
          </div>

          {/* Bloc SEO sectoriel */}
          <div className="mt-12 max-w-4xl mx-auto">
            <p data-animate className="text-gray-600 text-center leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              Que vous soyez dans la <strong>banque et assurance</strong>, le <strong>retail et e-commerce</strong>, l'<strong>industrie et énergie</strong> ou une <strong>startup</strong> en croissance, <strong>NailixIA</strong> adapte ses solutions d'<strong>IA</strong> et de <strong>transformation digitale</strong> à vos enjeux métiers spécifiques.
            </p>
          </div>

          <div className="mt-10 text-center">
            <p data-animate className="text-gray-600 mb-8 font-medium text-center leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              Des entreprises nous font confiance
            </p>
            <div className="flex flex-wrap justify-center items-center gap-8">
              {clients.map((client, index) => (
                  <div key={index} className="h-10 flex items-center">
                    {client.type === "img" ? (
                        <img
                            src={client.logo}
                            alt={client.name}
                            className="h-14 object-contain"
                        />
                    ) : (
                        <div className="max-w-full">
                          {client.logo}
                        </div>
                    )}
                  </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values Section - À propos de NailixIA - Optimisé SEO */}
      <section id="valeurs" className="py-20 px-6" data-testid="values-section" aria-labelledby="valeurs-title">
        <div className="container mx-auto">
          <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            À propos
          </p>
          <h2 id="valeurs-title" data-animate className="text-3xl md:text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Qui sommes-nous ?
          </h2>
          <p data-animate className="text-center text-gray-700 mb-4 max-w-3xl mx-auto text-sm md:text-xl font-semibold opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Un partenaire IA de bout en bout — de la formation à la mise en production
          </p>
          <p data-animate className="text-center text-gray-600 mb-12 max-w-3xl mx-auto text-sm md:text-lg leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            <strong>NailixIA</strong> est un <strong>cabinet de conseil spécialisé dans l'IA et les services digitaux</strong>. Nous accompagnons nos clients dans leur transformation en combinant <strong>expertise métier</strong>, <strong>maîtrise technologique</strong> et une <strong>approche orientée résultats</strong> — de la formation jusqu'au déploiement en production.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
                <article
                    key={index}
                    className="bg-white p-8 rounded-xl shadow-lg text-center hover-lift opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid={`value-card-${index}`}
                    data-animate
                >
                  <div data-animate className="text-accent flex justify-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">{value.icon}</div>
                  <h3 data-animate className="text-xl font-bold text-primary mb-3 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">{value.title}</h3>
                  <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">{value.description}</p>
                </article>
            ))}
          </div>
          <div className="mt-12 bg-accent bg-opacity-10 p-8 rounded-xl max-w-3xl mx-auto">
            <h3 data-animate className="text-2xl font-bold text-primary mb-4 text-center opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Notre ambition</h3>
            <p data-animate className="text-gray-800 text-center font-semibold mb-4 text-sm md:text-xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              Devenir un <strong>acteur clé de la transformation IA des entreprises</strong>, en combinant :
            </p>
            <ul data-animate className="text-gray-700 text-center text-sm md:text-xl space-y-2 mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              <li>• <strong>Expertise métier</strong> au service de vos enjeux business</li>
              <li>• <strong>Maîtrise technologique</strong> — IA, data, cloud, développement</li>
              <li>• <strong>Approche orientée résultats</strong> — pas de POC sans mise en production</li>
            </ul>
            <p data-animate className="text-gray-700 text-center italic opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              Ce que nous identifions, nous le construisons. Ce que nous construisons, nous le déployons.
            </p>
          </div>

          {/* Bloc SEO Marque NailixIA */}
          <div className="mt-12 max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-lg">
            <h3 data-animate className="text-xl md:text-2xl font-bold text-primary mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Pourquoi l'IA reste encore sous-exploitée en entreprise ?</h3>
            {/*<p data-animate className="text-gray-600 leading-relaxed mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">*/}
            {/*  Beaucoup d'entreprises expérimentent l'<strong>intelligence artificielle</strong> sans jamais en tirer un impact concret. Les raisons sont toujours les mêmes : une compréhension encore floue des capacités réelles de l'IA, des <strong>équipes peu formées et peu autonomes</strong>, des cas d'usage difficiles à identifier, et un passage à la production trop complexe.*/}
            {/*</p>*/}
            {/*<p data-animate className="text-gray-600 leading-relaxed mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">*/}
            {/*  <strong>NailixIA</strong> a été fondé pour résoudre exactement ce problème. Notre approche couvre l'intégralité de la chaîne : <strong>formation des équipes</strong>, identification des cas d'usage à fort impact, <strong>développement de solutions sur mesure</strong> et déploiement en production — avec un accompagnement dans la durée.*/}
            {/*</p>*/}
            {/*<p data-animate className="text-gray-600 leading-relaxed mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">*/}
            {/*  Contrairement aux acteurs traditionnels qui s'arrêtent à la stratégie, à la formation ou au développement, <strong>NailixIA fait le lien entre tout</strong>. Nos consultants sont formés 360° à l'IA et intègrent directement vos équipes pour accélérer vos projets.*/}
            {/*</p>*/}
            {/*<p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">*/}
            {/*  Basée en France, <strong>NailixIA</strong> accompagne des clients de tous secteurs — <strong>médias</strong>, <strong>banque</strong>, <strong>assurance</strong>, <strong>retail</strong>, <strong>industrie</strong>, <strong>startups</strong> et <strong>scale-ups</strong> — avec une référence notable : <strong>Le Figaro</strong>, pour qui nous avons déployé une formation IA et des premières briques d'automatisation RH.*/}
            {/*</p>*/}

            <div className="flex items-center gap-4 mb-4">
              <div className="bg-red-300 w-6 h-6 flex items-center justify-center rounded-full">
                <X data-animate className="text-red-700 w-4 h-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"/>
              </div>
              <p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Compréhension floue des capacités réelles de l'IA</p>
            </div>

            <div className="flex items-center gap-4 mb-4">
              <div className="bg-red-300 w-6 h-6 flex items-center justify-center rounded-full">
                <X data-animate className="text-red-700 w-4 h-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"/>
              </div>
              <p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Équipes peu formées et peu autonomes</p>
            </div>

            <div className="flex items-center gap-4 mb-4">
              <div className="bg-red-300 w-6 h-6 flex items-center justify-center rounded-full">
                <X data-animate className="text-red-700 w-4 h-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"/>
              </div>
              <p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Passage à la production trop complexe</p>
            </div>

            <div className="bg-accent/20 rounded-xl w-fit p-4 mx-auto border-l-4 border-accent">
              <p data-animate className="text-gray-600 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">NailixIA résout exactement ce problème — de la formation jusqu'au déploiement en production.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Careers Section - Optimisé SEO */}
      <section id="carrieres" className="py-20 px-6 bg-white" data-testid="careers-section" aria-labelledby="carrieres-title">
        <div className="container mx-auto max-w-4xl">
          <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            Carrière
          </p>
          <h2 id="carrieres-title" data-animate className="text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Rejoins NailixIA
          </h2>
          <p data-animate className="text-center text-gray-600 mb-12 text-lg leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Construis ton parcours avec une équipe formée à l'IA et participe à la conception de solutions et agents IA à forte valeur ajoutée.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <article data-animate className="bg-background p-6 rounded-xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              <div className="w-12 h-12 bg-accent/20 flex items-center justify-center rounded-xl mb-2">
                <div data-animate className="text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">
                  <Users />
                </div>
              </div>
              <h4 data-animate className="font-bold text-primary mb-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Suivi RH & missions</h4>
              <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Accompagnement personnalisé tout au long des missions.</p>
            </article>
            <article data-animate className="bg-background p-6 rounded-xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              <div className="w-12 h-12 bg-accent/20 flex items-center justify-center rounded-xl mb-2">
                <div data-animate className="text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">
                  <Rocket />
                </div>
              </div>
              <h4 data-animate className="font-bold text-primary mb-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Projets stimulants</h4>
              <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Opportunités sur des missions variées et challenges intéressants.</p>
            </article>
            <article data-animate className="bg-background p-6 rounded-xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              <div className="w-12 h-12 bg-accent/20 flex items-center justify-center rounded-xl mb-2">
                <div data-animate className="text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">
                  <TrendingUp />
                </div>
              </div>
              <h4 data-animate className="font-bold text-primary mb-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Développement de carrière</h4>
              <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Perspectives d'évolution réfléchies et progression structurée.</p>
            </article>
            <article data-animate className="bg-background p-6 rounded-xl opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
              <div className="w-12 h-12 bg-accent/20 flex items-center justify-center rounded-xl mb-2">
                <div data-animate className="text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" aria-hidden="true">
                  <GraduationCap />
                </div>
              </div>
              <h4 data-animate className="font-bold text-primary mb-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Formation continue IA</h4>
              <p data-animate className="text-gray-600 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Montée en compétences sur l'IA et actualisation régulière des connaissances technologiques.</p>
            </article>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 data-animate className="text-2xl font-bold text-primary mb-6 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Envoyer ma candidature</h3>
            <form onSubmit={handleCareerSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Prénom *"
                  required
                  value={careerForm.firstName}
                  onChange={(e) => setCareerForm({...careerForm, firstName: e.target.value})}
                  className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="career-firstname-input"
                  data-animate
                />
                <input
                  type="text"
                  placeholder="Nom *"
                  required
                  value={careerForm.lastName}
                  onChange={(e) => setCareerForm({...careerForm, lastName: e.target.value})}
                  className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="career-lastname-input"
                  data-animate
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="email"
                  placeholder="Email *"
                  required
                  value={careerForm.email}
                  onChange={(e) => setCareerForm({...careerForm, email: e.target.value})}
                  className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="career-email-input"
                  data-animate
                />
                <input
                  type="tel"
                  placeholder="Téléphone *"
                  required
                  value={careerForm.phone}
                  onChange={(e) => setCareerForm({...careerForm, phone: e.target.value})}
                  className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="career-phone-input"
                  data-animate
                />
              </div>
              <input
                type="text"
                placeholder="Poste recherché / Compétence principale *"
                required
                value={careerForm.position}
                onChange={(e) => setCareerForm({...careerForm, position: e.target.value})}
                className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid="career-position-input"
                data-animate
              />
              <input
                type="text"
                placeholder="Lien CV / LinkedIn / GitHub"
                value={careerForm.cvLink}
                onChange={(e) => setCareerForm({...careerForm, cvLink: e.target.value})}
                className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid="career-cvlink-input"
                data-animate
              />
              <textarea
                placeholder="Message"
                rows="4"
                value={careerForm.message}
                onChange={(e) => setCareerForm({...careerForm, message: e.target.value})}
                className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid="career-message-input"
                data-animate
              ></textarea>
              <button 
                type="submit"
                className="w-full bg-accent text-white py-3 rounded-lg font-semibold hover:bg-opacity-90 transition opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                data-testid="career-submit-btn"
                data-animate
              >
                Envoyer ma candidature
              </button>
              {careerStatus.message && (
                <div 
                  className={`p-4 rounded-lg ${
                    careerStatus.type === 'success' ? 'bg-green-100 text-green-700' : 
                    careerStatus.type === 'error' ? 'bg-red-100 text-red-700' : 
                    'bg-blue-100 text-blue-700'
                  }`}
                  data-testid="career-status-message"
                >
                  {careerStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Contact Section - Optimisé SEO */}
      <section id="contact" className="py-20 px-6" data-testid="contact-section" aria-labelledby="contact-title" itemScope itemType="https://schema.org/ContactPage">
        <div className="container mx-auto max-w-4xl">
          <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
            Contact
          </p>
          <h2 id="contact-title" data-animate className="text-4xl font-bold text-primary text-center mb-4 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Contactez NailixIA – Parlons de Votre Projet IA
          </h2>
          <p data-animate className="text-center text-gray-600 mb-12 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
            Vous avez un projet de <strong>transformation digitale</strong>, besoin de consultants <strong>IA</strong> ou d'<strong>agents IA</strong> sur mesure ? <strong>NailixIA</strong> vous répond sous 24h.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 data-animate className="text-2xl font-bold text-primary mb-6 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Envoyez-nous un message</h3>
              <form onSubmit={handleContactSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Prénom *"
                    required
                    value={contactForm.firstName}
                    onChange={(e) => setContactForm({...contactForm, firstName: e.target.value})}
                    className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid="contact-firstname-input"
                    data-animate
                  />
                  <input
                    type="text"
                    placeholder="Nom *"
                    required
                    value={contactForm.lastName}
                    onChange={(e) => setContactForm({...contactForm, lastName: e.target.value})}
                    className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid="contact-lastname-input"
                    data-animate
                  />
                </div>
                <input
                  type="text"
                  placeholder="Société *"
                  required
                  value={contactForm.company}
                  onChange={(e) => setContactForm({...contactForm, company: e.target.value})}
                  className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="contact-company-input"
                  data-animate
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="email"
                    placeholder="Email *"
                    required
                    value={contactForm.email}
                    onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                    className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid="contact-email-input"
                    data-animate
                  />
                  <input
                    type="tel"
                    placeholder="Téléphone *"
                    required
                    value={contactForm.phone}
                    onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                    className="border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    data-testid="contact-phone-input"
                    data-animate
                  />
                </div>
                <select
                  value={contactForm.needType}
                  onChange={(e) => setContactForm({...contactForm, needType: e.target.value})}
                  className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="contact-needtype-select"
                  data-animate
                >
                  <option>Recruter un profil</option>
                  <option>Confier un projet</option>
                  <option>Autre</option>
                </select>
                <textarea
                  placeholder="Votre message *"
                  rows="4"
                  required
                  value={contactForm.message}
                  onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                  className="w-full border border-neutral rounded-lg px-4 py-3 focus:outline-none focus:border-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="contact-message-input"
                  data-animate
                ></textarea>
                <button 
                  type="submit"
                  className="w-full bg-accent text-white py-3 rounded-lg font-semibold hover:bg-opacity-90 transition opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                  data-testid="contact-submit-btn"
                  data-animate
                >
                  Envoyer
                </button>
                {contactStatus.message && (
                  <div 
                    className={`p-4 rounded-lg ${
                      contactStatus.type === 'success' ? 'bg-green-100 text-green-700' : 
                      contactStatus.type === 'error' ? 'bg-red-100 text-red-700' : 
                      'bg-blue-100 text-blue-700'
                    }`}
                    data-testid="contact-status-message"
                  >
                    {contactStatus.message}
                  </div>
                )}
              </form>
            </div>

            <div className="space-y-6">
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h3 className="text-2xl font-bold text-primary mb-6">Nos coordonnées</h3>
                <div className="space-y-4">
                  <div className="flex items-center gap-2">
                    <div data-animate className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                      <Mail data-animate className="w-6 h-6 text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" />
                    </div>
                    <div>
                      <p data-animate className="font-semibold text-primary opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Email</p>
                      <a href="mailto:contact@nailixia.com" data-animate className="text-gray-600 hover:text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                        contact@nailixia.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div data-animate className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                      <Phone data-animate className="w-6 h-6 text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" />
                    </div>
                    <div>
                      <p data-animate className="font-semibold text-primary opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Téléphone</p>
                      <a href="tel:+33680422977" data-animate className="text-gray-600 hover:text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">+33 6 80 42 29 77</a>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div data-animate className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                      <Linkedin data-animate className="w-6 h-6 text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" />
                    </div>
                    <div>
                      <p data-animate className="font-semibold text-primary opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">LinkedIn</p>
                      <a href="https://linkedin.com/company/nailixia" target="_blank" rel="noopener noreferrer" data-animate className="text-gray-600 hover:text-accent break-all opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                        linkedin.com/company/nailixia
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-accent bg-opacity-10 p-8 rounded-xl">
                <h4 data-animate className="font-bold text-primary mb-2 flex items-center before:content-[''] before:w-2 before:h-2 before:bg-accent before:rounded-full before:inline-block gap-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">Réponse rapide garantie</h4>
                <p data-animate className="text-gray-700 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                  Notre équipe s'engage à vous répondre sous 24h ouvrées. Pour toute urgence, n'hésitez pas à nous appeler directement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showButton && (
        <aside className="w-10 h-10 fixed bottom-6 right-6 flex items-center rounded-full justify-center bg-accent/30 text-gray-700 shadow-lg"
               onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        >
          <ArrowUp className="w-5 h-5" />
        </aside>
      )}

      {/* Footer - Optimisé SEO */}
      <footer className="bg-primary text-white py-12 px-6" role="contentinfo" itemScope itemType="https://schema.org/Organization">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row justify-between md:items-center">
            <div className="mb-6 md:mb-0">
              <h3 className="text-3xl font-bold text-white mb-2">
                <span itemProp="name">Nailix</span><span className="text-accent">IA</span>
              </h3>
              <p className="text-gray-300 mb-2" itemProp="description">De la formation à la mise en production de solutions IA</p>
              <p className="text-gray-400 text-sm">© 2025 NailixIA - Tous droits réservés</p>
              <meta itemProp="url" content="https://nailixia.com" />
            </div>
            <div className="flex flex-col md:flex-row gap-6">
              <button className="text-gray-300 hover:text-accent transition text-left">Mentions légales</button>
              <button className="text-gray-300 hover:text-accent transition text-left">Politique de confidentialité</button>
              <a 
                href="https://linkedin.com/company/nailixia" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-accent transition"
                aria-label="Suivre NailixIA sur LinkedIn"
                itemProp="sameAs"
              >
                LinkedIn
              </a>
            </div>
          </div>
          
          {/* Footer SEO Text */}
          <div className="mt-8 pt-8 border-t border-gray-600">
            <p className="text-gray-400 text-sm text-center max-w-3xl mx-auto">
              <strong>NailixIA</strong> est un cabinet de conseil français spécialisé dans l'IA et les services digitaux.
              De la formation à la mise en production de solutions IA — formation des équipes, identification de cas d'usage,
              développement sur mesure et déploiement. Référence : Le Figaro.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
